import { PolicyLayout, useSettings, ConfigField } from "@/components/PolicyLayout";

export default function ReturnPolicy() {
  const s = useSettings();
  return (
    <PolicyLayout title="Return & Replacement Policy" kicker="Easy, honest returns">
      <p>Our goal at {s.brand} is that you love what you receive. If something is not right, we'll help you replace or return it. Please read the policy below carefully — it is designed to be simple and fair to both sides.</p>

      <h2>1. Return / replacement window</h2>
      <p>You may request a return or replacement within <b>7 days from the date of delivery</b>. Requests raised after 7 days will not be eligible.</p>

      <h2>2. Eligible items</h2>
      <p>The following items are eligible for return or replacement, provided they are unopened, unused, and in their original packaging:</p>
      <ul>
        <li>Idols, murtis, brass items (thali, panchpatra, lota, kalash, bell, shankh)</li>
        <li>Diyas and lamps (unused)</li>
        <li>Rudraksha, malas and spiritual accessories (with all tags and packaging intact)</li>
        <li>Havan kunds and related utensils</li>
      </ul>

      <h2>3. Non-returnable items (for hygiene / religious reasons)</h2>
      <p>Unless received damaged, wrong or defective, the following are <b>not eligible for return</b>:</p>
      <ul>
        <li>Consumable puja samagri: roli, kumkum, chandan, akshat, moli, ghee, oil, camphor, agarbatti, dhoop, panchmeva, mishri, dry fruits and any packaged samagri that has been opened</li>
        <li>Customized puja kits assembled to your specific requirement</li>
        <li>Fresh flowers, malas and perishable items</li>
      </ul>

      <h2>4. Damaged, wrong or defective product</h2>
      <p>If your item arrives damaged, is a wrong product, or is defective, we will replace it at no cost. Please report within <b>48 hours of delivery</b> with:</p>
      <ol>
        <li>Order number</li>
        <li>Clear photographs of the outer parcel and the product</li>
        <li>A short description of the issue</li>
      </ol>
      <p>Send these to <ConfigField value={s.email} label="business email"/>. Our team will verify and arrange a free reverse pickup (where available) or ask you to courier it back at our cost.</p>

      <h2>5. How to request a return or replacement</h2>
      <ol>
        <li>Email <ConfigField value={s.email} label="business email"/> with your order number and reason.</li>
        <li>Our team will confirm eligibility and reply within one business day.</li>
        <li>Once approved, we'll arrange a reverse pickup where the courier partner is serviceable, or share our warehouse address for self-shipment.</li>
        <li>Ship the item back in its original packaging, unused, with tags. Please write your order number on the outer parcel.</li>
        <li>Once we receive the item and verify condition, we will process your replacement or refund within 3 business days.</li>
      </ol>

      <h2>6. Replacement or refund?</h2>
      <ul>
        <li><b>Replacement</b> — chosen where the same product is in stock and you'd like the same item.</li>
        <li><b>Refund</b> — chosen if you prefer money back or if the product is unavailable. Refunds follow our <a href="/refund-policy">Refund & Cancellation Policy</a>.</li>
      </ul>

      <h2>7. Return shipping charges</h2>
      <ul>
        <li>If the return is due to a mistake on our side (damaged, wrong, defective item): <b>we bear the return cost fully</b>.</li>
        <li>If you are returning a product for personal reasons (changed your mind, wrong size chosen, etc.): return shipping is borne by the customer.</li>
      </ul>

      <h2>8. What if the product is damaged in return transit?</h2>
      <p>Please pack the return parcel well so that the courier does not damage it in transit. If a returned item is received in a damaged condition due to poor packing, we may not be able to process the refund/replacement.</p>

      <h2>9. Questions?</h2>
      <p>Reach us via <a href="/contact">Contact page</a>, email <ConfigField value={s.email} label="business email"/>, or WhatsApp during our support hours.</p>
    </PolicyLayout>
  );
}
